// extracted by mini-css-extract-plugin
export default {"trackVertical":"styles_trackVertical__x4Ovr","thumbVertical":"styles_thumbVertical__6yxu6"};